var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelf3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3H25.5C26.6935 3 27.8381 3.47411 28.682 4.31802C29.5259 5.16193 30 6.30653 30 7.5V28.5C30 29.6935 29.5259 30.8381 28.682 31.682C27.8381 32.5259 26.6935 33 25.5 33H10.5C9.30653 33 8.16193 32.5259 7.31802 31.682C6.47411 30.8381 6 29.6935 6 28.5V7.5C6 6.30653 6.47411 5.16193 7.31802 4.31802C8.16193 3.47411 9.30653 3 10.5 3ZM12 13.5C11.6022 13.5 11.2206 13.658 10.9393 13.9393C10.658 14.2206 10.5 14.6022 10.5 15C10.5 15.3978 10.658 15.7794 10.9393 16.0607C11.2206 16.342 11.6022 16.5 12 16.5H24C24.3978 16.5 24.7794 16.342 25.0607 16.0607C25.342 15.7794 25.5 15.3978 25.5 15C25.5 14.6022 25.342 14.2206 25.0607 13.9393C24.7794 13.658 24.3978 13.5 24 13.5H12ZM12 25.5C11.6022 25.5 11.2206 25.658 10.9393 25.9393C10.658 26.2206 10.5 26.6022 10.5 27C10.5 27.3978 10.658 27.7794 10.9393 28.0607C11.2206 28.342 11.6022 28.5 12 28.5H19.5C19.8978 28.5 20.2794 28.342 20.5607 28.0607C20.842 27.7794 21 27.3978 21 27C21 26.6022 20.842 26.2206 20.5607 25.9393C20.2794 25.658 19.8978 25.5 19.5 25.5H12ZM12 7.5C11.6022 7.5 11.2206 7.65804 10.9393 7.93934C10.658 8.22064 10.5 8.60218 10.5 9C10.5 9.39782 10.658 9.77936 10.9393 10.0607C11.2206 10.342 11.6022 10.5 12 10.5H24C24.3978 10.5 24.7794 10.342 25.0607 10.0607C25.342 9.77936 25.5 9.39782 25.5 9C25.5 8.60218 25.342 8.22064 25.0607 7.93934C24.7794 7.65804 24.3978 7.5 24 7.5H12ZM12 19.5C11.6022 19.5 11.2206 19.658 10.9393 19.9393C10.658 20.2206 10.5 20.6022 10.5 21C10.5 21.3978 10.658 21.7794 10.9393 22.0607C11.2206 22.342 11.6022 22.5 12 22.5H24C24.3978 22.5 24.7794 22.342 25.0607 22.0607C25.342 21.7794 25.5 21.3978 25.5 21C25.5 20.6022 25.342 20.2206 25.0607 19.9393C24.7794 19.658 24.3978 19.5 24 19.5H12Z",
    fill: "url(#paint0_linear_1681_4213)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1681_4213",
    x1: 6,
    y1: -0.750001,
    x2: 37.8358,
    y2: 27.1456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D6EB5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelf3);
export default __webpack_public_path__ + "static/media/Self3.575985c643e60e8d2990276984339615.svg";
export { ForwardRef as ReactComponent };